import { Component, OnInit } from "@angular/core";
import { LoginService } from "../login.service";
import { TranslateService } from "@ngx-translate/core";
import { SafeStyle, DomSanitizer } from "@angular/platform-browser";

@Component({
    selector: "app-login",
    templateUrl: "./login.component.html",
    styleUrls: ["./login.component.scss"],
    standalone: false
})
export class LoginComponent implements OnInit {
  user: string;
  pw: string;
  error: string;
  code: string;
  hidepw = true;
  typed = false;
  showLogin = false;

  constructor(public loginService: LoginService, private translate: TranslateService, private sanitizer: DomSanitizer) {
    this.translate.use("en-US"); //load tranlations for non prinouts - regular login
  }

  // Mirrors usgaweb: the alt splash replaces the login background when a
  // clinic has one configured, otherwise the standard artwork is used.
  getBackgroundImage(): SafeStyle {
    const imageUrl = this.loginService.altSplashPage
      ? this.loginService.altSplashPage
      : "assets/bg/login.jpg";

    return this.sanitizer.bypassSecurityTrustStyle(`url(${imageUrl})`);
  }

  ngOnInit() {}

  checkLogin() {
    // this.loginService.totpVerify = true;
    if (!this.loginService.getCode) this.loginService.login(this.user, this.pw);
    else this.loginService.sendCode(this.code);
  }

  clean() {
    try {
      this.user = this.user.replace(/[^\x00-\x7F]+/, "");
      this.pw = this.pw.replace(/[^\x00-\x7F]+/, "");
    } catch {}
  }

  setClinic(index: number) {
    this.loginService.setClinic(index);
  }
  getotp() {
    if (this.loginService.isCardio) this.checkLogin();
    else {
      var resp = this.loginService.getTOTP(this.user, this.pw);
      resp.subscribe(async (data: any) => {
        this.loginService.totpVerify = data;
        if (data) {
          this.showLogin = true;
        } else {
          this.checkLogin();
        }
      });
    }
  }
  viewonly() {}
}
